import STSRepeatedAttemptTestBase from './STSRepeatedAttemptTestBase';
import type { StsRepetitionResultPayload } from '../sts/stsDomain';

interface STS30sTestProps {
  initial?: StsRepetitionResultPayload | null;
  patientContext?: {
    birthDate?: string | null;
    ageYears?: number | null;
    sex?: string | null;
    weightKg?: number | null;
    heightCm?: number | null;
    identifier?: string | null;
  };
  onCancel?: () => void;
  onDraftAttempt?: (payload: StsRepetitionResultPayload) => Promise<boolean | void> | boolean | void;
  onNext: (result: StsRepetitionResultPayload) => void;
}

export type { StsRepetitionResultPayload as STS30sResultPayload };

export default function STS30sTest(props: STS30sTestProps) {
  return (
    <STSRepeatedAttemptTestBase
      {...props}
      testKey="STS_30S"
      title="Sentar-Levantar de 30 s (30 s STS)"
      description="Posição inicial sentado, braços cruzados. Instrução: levante e sente o maior número de vezes possível em 30 segundos. Realize 2 tentativas e registre ambas. Descanso recomendado: 2-3 min."
      durationSeconds={30}
      recommendedRestSeconds={180}
      allowFinalizeAfterFirstAttempt={false}
      saveLabel="Salvar 30 s STS"
    />
  );
}
